const CALCULATOR = {
    MAX: 1260,
};

const DESKTOP = {
    MIN: 1025,
    MAX: 1600,
};

const LAPTOP = {
    MIN: 768,
    MAX: 1024,
};

const LARGE_DESKTOP = {
    MIN: 1440,
};

const MOBILE = {
    MAX: 767,
};

const MOBILE_TABLET = {
    MAX: 1024,
};

const XS_TABLET = {
    MAX: 959,
};

const TABLET = {
    MIN: 768,
    MAX: 1024,
};

const XS_MOBILE = {
    MAX: 360,
};

export { CALCULATOR, DESKTOP, LAPTOP, LARGE_DESKTOP, MOBILE, MOBILE_TABLET, XS_TABLET, TABLET, XS_MOBILE };

export default {
    CALCULATOR,
    DESKTOP,
    LAPTOP,
    LARGE_DESKTOP,
    MOBILE,
    MOBILE_TABLET,
    XS_TABLET,
    TABLET,
    XS_MOBILE,
};
